import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { ESetCurrentLayoutActionType, TSetCurrentLayout } from './types';
import { ISettings } from '../../../types/settings';

export const setCurrentLayout: (name: ISettings['currentLayout']) => TSetCurrentLayout = actionGenerator<
  ESetCurrentLayoutActionType.Set,
  ISettings['currentLayout']
>(ESetCurrentLayoutActionType.Set);
